/* MXDVS product page, lower part (29.09.2026)
   - Dropdowns under the button slide open and closed (details[data-slide]).
   - Description: builds the file header, copy, spec rows and small print from the product's own HTML classes
     (product-limited, product-handmade, product-description, product-info-list, product-supplies).
     The model line (product-model-size) and the old PNG size chart (size-chart-jQuery-toggle) are left out:
     the model line is the photo caption, the size chart has its own panel.
   - Care: "Washing instructions" opens the care panel when the product has a Care entry (metafield mxdvs.care).
   - You may also like: tabs, Suggested from Shopify's recommendations, quick add with sizes.
   - Reviews: restyles the Judge.me widget, first 3 reviews + "Show more reviews", translate for non-English reviews.
   07.10.2026: the terminal path (~/store.mxdvs.co/collections/<type>/) sits above the product photos instead of above the
   name, on every product page. You may also like: switching tabs slides the cards in the direction of the tab buttons
   (a tab to the right: the old cards leave to the left and the new ones come in from the right; a tab to the left: the other way).
   09.10.2026: description cleaned up (tags, running text, spec rows without bullets, note band; the washing link has its own tile);
   terminal path on phones above Product details, on desktop above the product name; the washing panel follows the finger on
   phones; Write a review keeps Judge.me's own link in place (hidden) and our button clicks it. */
(function () {
  if (window.MxLower) return;
  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var GL = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  function decode(el, text, dur) {
    if (!el) return;
    if (RM) { el.textContent = text; return; }
    dur = dur || 500; var t0 = performance.now(), id = (el._mxl || 0) + 1; el._mxl = id;
    (function f(now) {
      if (el._mxl !== id) return;
      var k = Math.min(1, (now - t0) / dur), s = '';
      for (var i = 0; i < text.length; i++) s += (k >= (i + 1) / text.length || /[\s.,:;!?'"’“”()-]/.test(text[i])) ? text[i] : GL[(Math.random() * GL.length) | 0];
      el.textContent = s;
      if (k < 1) requestAnimationFrame(f);
    })(t0);
  }
  var toastEl = null;
  function toast(t) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'mxl-toast'; toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.textContent = t; toastEl.classList.add('is-on'); clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 1800);
  }

  /* ---------- Dropdowns: slide open and closed. On phones only one is open at a time. ---------- */
  function slide(det, open) {
    var wrap = det.querySelector('.pp-acc__wrap');
    if (!wrap || RM) { det.open = open; return; }
    if (!open) {
      wrap.style.height = wrap.scrollHeight + 'px';
      requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.style.height = '0px'; }); });
      wrap.addEventListener('transitionend', function () { det.open = false; wrap.style.height = ''; }, { once: true });
    } else {
      det.open = true; wrap.style.height = '0px';
      requestAnimationFrame(function () { wrap.style.height = wrap.scrollHeight + 'px'; });
      wrap.addEventListener('transitionend', function () { wrap.style.height = ''; }, { once: true });
    }
  }
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('details[data-slide] > summary'); if (!sum) return;
    var det = sum.parentNode; if (!det.querySelector('.pp-acc__wrap')) return;
    e.preventDefault();
    var opening = !det.open;
    if (opening && window.innerWidth < 990 && det.parentNode) {
      Array.prototype.forEach.call(det.parentNode.querySelectorAll(':scope > details[data-slide][open]'), function (o) { if (o !== det) slide(o, false); });
    }
    slide(det, opening);
  });

  /* ---------- Panels on desktop: the close button sits centred under the cart icon in the header ---------- */
  function cartR() {
    if (innerWidth < 990) return;
    var best = null;
    Array.prototype.forEach.call(document.querySelectorAll('#cart-icon-bubble, [data-mx-cart-icon], .header__icon--cart, a[href$="/cart"]'), function (el) {
      var r = el.getBoundingClientRect();
      if (r.width && r.top >= 0 && r.top < 200 && (!best || r.right > best.right)) best = r;
    });
    if (best) document.documentElement.style.setProperty('--mxp-cart-r', Math.round(innerWidth - (best.left + best.width / 2)) + 'px');
  }
  window.addEventListener('load', cartR);
  window.addEventListener('resize', cartR);
  document.addEventListener('click', cartR, true);

  /* ---------- Rating link under the title: glide down to the reviews ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#judgeme_product_reviews"], a[href="#reviews"]'); if (!a) return;
    var target = document.getElementById('reviews') || document.getElementById('judgeme_product_reviews'); if (!target) return;
    e.preventDefault();
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 17.5, behavior: RM ? 'auto' : 'smooth' });
  });

  /* ---------- Care symbols (line icons) ---------- */
  var T = function (x, y, t) { return '<text x="' + x + '" y="' + y + '" text-anchor="middle" font-family="Roboto Mono,monospace" font-size="6" font-weight="700" fill="currentColor" stroke="none">' + t + '</text>'; };
  var TUB = '<path d="M3 9 L5 20 H19 L21 9"/><path d="M3 9 q2.25 -2.5 4.5 0 t4.5 0 t4.5 0 t4.5 0"/>';
  var X = '<path d="M3 3 L21 21 M21 3 L3 21"/>';
  var TRI = '<path d="M12 3.5 L21.5 20 H2.5 Z"/>';
  var SQ = '<rect x="3.5" y="3.5" width="17" height="17"/>';
  var IRON = '<path d="M3 18.5 H21 L19 10 H8.5 C5.5 10 4 13.5 3 18.5 Z"/><path d="M9 10 V6.5 H17.5 V10"/>';
  var dot = function (x, y) { return '<circle cx="' + x + '" cy="' + y + '" r="1" fill="currentColor"/>'; };
  var CARE = {
    'Hand wash': TUB + '<path d="M9.5 16 v-3.5 m2 3.5 v-4.5 m2 4.5 v-3.5 m-5.5 2 q0 3 3.5 3 q3.5 0 4 -3"/>',
    'Machine wash 30°C': TUB + T(12, 17.5, '30'),
    'Machine wash 40°C': TUB + T(12, 17.5, '40'),
    'Do not wash': TUB + X,
    'Do not bleach': TRI + '<path d="M6 8 L18 20 M18 8 L6 20"/>',
    'Do not tumble dry': SQ + '<circle cx="12" cy="12" r="5.5"/>' + X,
    'Tumble dry low': SQ + '<circle cx="12" cy="12" r="5.5"/>' + dot(12, 12),
    'Dry flat': SQ + '<path d="M7 12 H17"/>',
    'Line dry': SQ + '<path d="M3.5 3.5 Q12 12 20.5 3.5"/>',
    'Iron low': IRON + dot(12, 15),
    'Iron medium': IRON + dot(10.5, 15) + dot(13.5, 15),
    'Do not iron': IRON + X,
    'Dry clean': '<circle cx="12" cy="12" r="8.5"/>' + T(12, 14.5, 'P'),
    'Do not dry clean': '<circle cx="12" cy="12" r="8.5"/>' + X
  };
  var icon = function (k) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true">' + (CARE[k] || '') + '</svg>'; };
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 4l16 16M20 4L4 20"/></svg>';

  var layer = null, lastFocus = null;
  function panel(html) {
    if (!layer) {
      layer = document.createElement('div'); layer.className = 'pp-layer'; layer.setAttribute('aria-hidden', 'true');
      layer.innerHTML = '<div class="pp-backdrop" data-close></div><div class="pp-dialog pp-dialog--care" role="dialog" aria-modal="true" aria-label="Care"></div>';
      document.body.appendChild(layer);
      layer.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) shut(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && layer.classList.contains('is-open')) shut(); });
    }
    lastFocus = document.activeElement;
    var d = layer.querySelector('.pp-dialog'); d.innerHTML = html; d.scrollTop = 0;
    if (window.MxSheetDrag && !d._drag) d._drag = window.MxSheetDrag.attach(d, { close: shut, backdrop: layer.querySelector('.pp-backdrop'), closePct: 25, flick: 0.6, snapMs: 280 });
    layer.classList.add('is-open'); layer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mxp-lock');
    var c = d.querySelector('.pp-close'); if (c) c.focus({ preventScroll: true });
  }
  function shut() {
    layer.classList.remove('is-open'); layer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mxp-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function careHTML(care, title) {
    var h = '<div class="pp-dialog__head"><h2 class="pp-dialog__title">' + esc(care.label || 'Care') + '</h2><button type="button" class="pp-close" data-close aria-label="Close">' + CLOSE + '</button></div>';
    h += '<div class="pp-block"><h3 class="pp-h">' + esc(title) + '</h3>' + (care.fabric ? '<p class="pp-sub">' + esc(care.fabric) + '</p>' : '') + '</div>';
    if (care.note) h += '<div class="pp-band"><b>' + esc(care.noteLabel || 'Care note:') + '</b> ' + esc(care.note) + '</div>';
    var sy = (care.symbols || []).filter(function (k) { return CARE[k]; });
    if (sy.length) h += '<div class="pp-block"><div class="pp-row"><span class="pp-label">' + esc(care.symbolsLabel || 'Symbols') + '</span></div><div class="pl-care">' + sy.map(function (k) { return '<div class="pl-care__row">' + icon(k) + '<span>' + esc(k) + '</span></div>'; }).join('') + '</div></div>';
    if (care.text) h += '<div class="pp-block"><div class="pp-row"><span class="pp-label">' + esc(care.textLabel || 'How to care') + '</span></div><p class="pl-care__text">' + esc(care.text).replace(/\n/g, '<br>') + '</p></div>';
    return h;
  }

  /* ---------- Description ---------- */
  function describe(box, care) {
    if (!box || box.dataset.plDone) return;
    box.dataset.plDone = '1';
    var tmp = document.createElement('div'); tmp.innerHTML = box.innerHTML;
    tmp.querySelectorAll('meta,script,style').forEach(function (n) { n.remove(); });
    var take = function (sel) { var el = tmp.querySelector(sel); if (el) el.remove(); return el; };
    var lim = take('.product-limited'), house = take('.product-handmade'), desc = take('.product-description'),
      list = take('.product-info-list'), sup = take('.product-supplies'), disc = take('.product-disclaimer');
    /* the model line is the photo caption, the old size chart has its own panel, the archived date shows under the name */
    take('.product-model-size'); take('.size-chart-jQuery-toggle'); take('.product-archived');
    if (!lim && !house && !desc && !list && !sup && !disc) { box.dataset.plDone = 'plain'; box.innerHTML = '<div class="pd"><div class="pd-copy">' + tmp.innerHTML + '</div></div>'; return; }
    var h = '', flags = [];
    if (lim) flags.push('<li>' + esc(lim.textContent.trim()) + '</li>');
    if (house) flags.push('<li class="is-house">' + esc(house.textContent.trim()) + '</li>');
    if (flags.length) h += '<ul class="pd-flags">' + flags.join('') + '</ul>';
    if (desc) {
      var text = desc.innerHTML.replace(/<\/?span[^>]*>/g, ''), m = text.match(/[“"]([^”"]+)[”"]/), quote = '';
      if (m) { quote = m[1]; text = text.replace(m[0], ''); }
      var paras = text.split(/(?:<br\s*\/?>\s*){2,}/i).map(function (p) { return p.trim(); }).filter(Boolean);
      h += '<div class="pd-copy">' + paras.map(function (p) { return '<p>' + p + '</p>'; }).join('') + '</div>';
      if (quote) h += '<p class="pd-quote">' + esc(quote) + '</p>';
    }
    if (list) {
      var rows = list.innerHTML.split(/<br\s*\/?>/i).map(function (s) { return s.replace(/^[\s•\-]+/, '').trim(); }).filter(Boolean);
      /* the washing link has its own tile under Included */
      rows = rows.filter(function (r) { return !(/<a /i.test(r) && /wash|care/i.test(r.replace(/<[^>]+>/g, ''))); });
      if (rows.length) h += '<ul class="pd-spec">' + rows.map(function (r) {
        var plain = r.replace(/<[^>]+>/g, '').trim(), i = plain.indexOf(':');
        if (/<a /i.test(r)) return '<li class="is-plain"><span class="v">' + r + '</span></li>';
        if (i > 0) return '<li><span class="k">' + esc(plain.slice(0, i)) + '</span><span class="v">' + esc(plain.slice(i + 1).trim()) + '</span></li>';
        return '<li class="is-plain"><span class="v">' + esc(plain) + '</span></li>';
      }).join('') + '</ul>';
    }
    if (sup) h += '<p class="pd-small">' + esc(sup.textContent.trim()) + '</p>';
    if (disc) h += '<p class="pd-noteband">' + disc.innerHTML.trim().replace(/^disclaimer:\s*/i, '<b>Note</b>').replace(/(<br\s*\/?>\s*){2,}/gi, '<br>') + '</p>';
    var rest = tmp.innerHTML.replace(/<br\s*\/?>/gi, '').replace(/<p>\s*<\/p>/g, '').trim();
    if (rest) h += '<div class="pd-copy">' + rest + '</div>';
    box.innerHTML = '<div class="pd">' + h + '</div>';
  }
  function initDetails(root) {
    /* 09.10.2026: the terminal path (home / collections / type): on phones above Product details (the first dropdown),
       on desktop above the product name; kept there after the page redraws and when the window changes size */
    var tpl = root.querySelector('[data-mxp-path]'), view = root.querySelector('[data-mxp-view]');
    if (tpl && view && !root.dataset.mxlPath) {
      root.dataset.mxlPath = '1';
      var place = function () {
        var info = view.querySelector('.pp-info'), after = info && info.querySelector('[data-mxp-after]');
        var target = innerWidth >= 990 ? info : after;
        if (target) {
          var all = view.querySelectorAll('.pp-path'), cur = all[0];
          for (var i = 1; i < all.length; i++) all[i].remove();
          if (!cur) { cur = tpl.cloneNode(true); cur.hidden = false; cur.removeAttribute('data-mxp-path'); }
          if (target.firstChild !== cur) target.insertBefore(cur, target.firstChild);
        }
        watchInfo();
      };
      place(); new MutationObserver(place).observe(view, { childList: true });
      var rsT = 0; window.addEventListener('resize', function () { clearTimeout(rsT); rsT = setTimeout(place, 120); });
    }
    /* Desktop: when the product info is taller than the window (details open), it sticks with its bottom
       35px above the window edge instead of its top, so Add to cart can always be reached */
    function fitInfo() {
      var info = view && view.querySelector('.pp-info'); if (!info) return;
      if (innerWidth < 990) { info.style.top = ''; return; }
      var t = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--mxp-top')) || 70, h = info.offsetHeight;
      info.style.top = h > innerHeight - t - 35 ? (innerHeight - h - 35) + 'px' : '';
    }
    var ro = 'ResizeObserver' in window ? new ResizeObserver(fitInfo) : null, seen = null;
    function watchInfo() {
      var info = view && view.querySelector('.pp-info');
      if (ro && info && info !== seen) { if (seen) ro.unobserve(seen); ro.observe(info); seen = info; }
      fitInfo();
    }
    if (view && !root.dataset.mxlFit) { root.dataset.mxlFit = '1'; window.addEventListener('resize', fitInfo); watchInfo(); }
    var cj = root.querySelector('[data-mxp-care]'), care = null;
    try { care = cj ? JSON.parse(cj.textContent) : null; } catch (e) { care = null; }
    if (care && !(care.symbols && care.symbols.length) && !care.text) care = null;
    root.querySelectorAll('[data-pl-desc]').forEach(function (b) { describe(b, care); });
    if (root.dataset.mxlCare) return;
    root.dataset.mxlCare = '1';
    document.addEventListener('click', function (e) {
      if (!care || !e.target.closest('[data-care]')) return;
      e.preventDefault(); panel(careHTML(care, care.title || ''));
    });
  }

  /* ---------- You may also like ---------- */
  function initRelated(sec) {
    if (sec.dataset.mxlReady) return; sec.dataset.mxlReady = '1';
    var tabs = sec.querySelector('[data-tabs]'), tabRun = 0;
    /* Tabs: the cards slide the way the buttons are ordered. A tab to the right of the open one: the old cards
       slide out to the left and the new ones in from the right. A tab to the left: out to the right, in from the left. */
    function show(key, animate) {
      var btns = Array.prototype.slice.call(sec.querySelectorAll('[data-tab]')), panels = Array.prototype.slice.call(sec.querySelectorAll('[data-panel]'));
      var nextP = sec.querySelector('[data-panel="' + key + '"]');
      var prevP = panels.filter(function (p) { return !p.hidden; })[0] || null;
      btns.forEach(function (b) { var on = b.dataset.tab === key; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
      var run = ++tabRun;
      panels.forEach(function (p) { if (p.getAnimations) p.getAnimations().forEach(function (a) { a.cancel(); }); });
      var swap = function () { panels.forEach(function (p) { p.hidden = p.dataset.panel !== key; }); };
      if (!animate || RM || !prevP || !nextP || prevP === nextP || !prevP.animate) { swap(); return; }
      var at = function (k) { for (var i = 0; i < btns.length; i++) if (btns[i].dataset.tab === k) return i; return 0; };
      var dir = at(key) > at(prevP.dataset.panel) ? 1 : -1;
      var out = prevP.animate([{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(' + (-dir * 70) + 'px)', opacity: 0 }], { duration: 220, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' });
      var done = false, fin = function () {
        if (done || run !== tabRun) return; done = true;
        swap(); out.cancel();
        nextP.animate([{ transform: 'translateX(' + (dir * 70) + 'px)', opacity: 0 }, { transform: 'translateX(0)', opacity: 1 }], { duration: 380, easing: 'cubic-bezier(.2,.8,.2,1)' });
      };
      /* the swap never waits on the animation alone: if the browser holds animations back, the new cards still show */
      out.onfinish = fin; setTimeout(fin, 260);
    }
    if (tabs) tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (b && !b.classList.contains('is-on')) show(b.dataset.tab, true); });
    /* Suggested: Shopify's related products, rendered by this same section */
    var url = sec.dataset.recUrl, target = sec.querySelector('[data-rec-target]');
    if (url && target) {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), grid = doc.querySelector('[data-rec-grid]');
        if (grid && grid.children.length) { target.innerHTML = grid.innerHTML; if (window.MxCard) MxCard.scan(target); }
        else dropSuggested();
      }).catch(dropSuggested);
    }
    function dropSuggested() {
      var b = sec.querySelector('[data-tab="suggested"]'), p = sec.querySelector('[data-panel="suggested"]');
      if (b) b.remove(); if (p) p.remove();
      var next = sec.querySelector('[data-tab]');
      if (next) show(next.dataset.tab); else sec.hidden = true;
    }
    /* Quick add: sizes slide in when there are variants, otherwise straight into the cart */
    sec.addEventListener('click', function (e) {
      var item = e.target.closest('.mxr__item'); if (!item) return;
      if (e.target.closest('[data-qa-open]')) {
        e.preventDefault();
        sec.querySelectorAll('.mxr__item.is-qa').forEach(function (x) { if (x !== item) x.classList.remove('is-qa'); });
        item.classList.toggle('is-qa'); return;
      }
      if (e.target.closest('[data-qa-close]')) { e.preventDefault(); item.classList.remove('is-qa'); return; }
      var add = e.target.closest('[data-qa-add]'); if (!add || add.disabled) return;
      e.preventDefault(); quickAdd(add, item, sec.dataset.openDrawer === 'true');
    });
  }
  function quickAdd(btn, item, openDrawer) {
    var plus = item.querySelector('.mxr__add');
    if (plus) plus.classList.add('is-busy');
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.qaAdd), quantity: 1, properties: { _source: 'product_page_related' } }], sections: sections, sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (plus) plus.classList.remove('is-busy');
      if (data.status) { toast(data.description || data.message || 'Could not add to cart'); return; }
      item.classList.remove('is-qa');
      if (plus) { plus.classList.add('is-done'); setTimeout(function () { plus.classList.remove('is-done'); }, 1800); }
      toast('+1 ' + (btn.dataset.qaName || ''));
      if (openDrawer && drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data);
      else {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data.sections && data.sections['cart-icon-bubble']) {
          var b = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
      }
    }).catch(function () { if (plus) plus.classList.remove('is-busy'); toast('Could not add to cart'); });
  }

  /* ---------- Reviews ---------- */
  /* Quick check when Judge.me gives no language: more common non-English words than English ones */
  var EN = /\b(the|and|is|it|this|with|was|for|very|great|good|love|quality|fit|of|to|my|i|you|but|so)\b/gi;
  var OTHER = /\b(het|een|de|en|van|niet|heel|zeer|mooi|echt|goed|le|la|les|et|est|très|pour|avec|und|der|die|das|ist|sehr|nicht|schön|el|los|muy|para|il|molto|per|con|che|och|är|jag|mycket)\b/gi;
  function looksForeign(text) {
    var en = (text.match(EN) || []).length, other = (text.match(OTHER) || []).length;
    return other >= 2 && other > en;
  }
  /* Judge.me builds its cards differently per device and version, so each card is rebuilt in our own markup
     from the data Judge.me gives (stars, date, name, place, verified, title, text, photos, reply). */
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  function fmtDate(el) {
    if (!el) return '';
    var raw = (el.getAttribute('data-content') || '').trim(), d = raw ? new Date(raw.replace(' UTC', 'Z').replace(' ', 'T')) : null;
    if (d && !isNaN(d)) return pad(d.getDate()) + '/' + pad(d.getMonth() + 1) + '/' + d.getFullYear();
    return el.textContent.trim();
  }
  /* Emoji in reviews: black and white, in colour when the card is hovered */
  var emo = function (html) { return html.replace(/(\p{Extended_Pictographic}(?:️|‍\p{Extended_Pictographic})*)/gu, '<span class="mxrv-emo">$1</span>'); };
  var starStr = function (n) { n = Math.max(0, Math.min(5, Math.round(n))); return new Array(n + 1).join('★') + new Array(6 - n).join('☆'); };
  function buildCard(rev) {
    if (rev.dataset.mxrvCard) return;
    var q = function (sel) { return rev.querySelector(sel); }, txt = function (el) { return el ? (el.innerText || el.textContent || '').trim() : ''; };
    var r = q('.jdgm-rev__rating'), score = r && r.dataset.score ? +r.dataset.score : (rev.querySelectorAll('.jdgm-rev__rating .jdgm--on').length || 5);
    var title = txt(q('.jdgm-rev__title')), body = txt(q('.jdgm-rev__body')), author = txt(q('.jdgm-rev__author')), place = txt(q('.jdgm-rev__location')).replace(/[()]/g, '').trim();
    var reply = txt(q('.jdgm-rev__reply'));
    var pics = Array.prototype.slice.call(rev.querySelectorAll('.jdgm-rev__pics img')).map(function (i) { return i.getAttribute('data-src') || i.currentSrc || i.src; }).filter(Boolean);
    var ok = rev.dataset.verifiedBuyer === 'true' || !!q('.jdgm-rev__buyer-badge');
    var h = '<div class="mxrv-card"><div class="mxrv-card__top"><span class="mxrv-card__stars" role="img" aria-label="' + score + ' out of 5">' + starStr(score) + '</span><span class="mxrv-card__date">' + esc(fmtDate(q('.jdgm-rev__timestamp'))) + '</span></div>';
    if (title) h += '<h3 class="mxrv-card__title" data-rt>' + emo(esc(title)) + '</h3>';
    h += '<div class="mxrv-card__body" data-rb>' + emo(esc(body).replace(/\n+/g, '<br>')) + '</div>';
    if (pics.length) h += '<div class="mxrv-card__pics">' + pics.map(function (src) { return '<img src="' + esc(src) + '" alt="" loading="lazy">'; }).join('') + '</div>';
    if (reply) h += '<div class="mxrv-card__reply">' + esc(reply) + '</div>';
    h += '<div class="mxrv-card__foot"><span><b>' + esc(author) + '</b>' + (place ? ' ' + esc(place) : '') + '</span>' + (ok ? '<span class="mxrv-card__ok">Verified</span>' : '') + '</div></div>';
    rev.insertAdjacentHTML('beforeend', h);
    rev.classList.add('mxrv-built'); rev.dataset.mxrvCard = '1';
  }
  function initReviews(sec) {
    if (sec.dataset.mxlReady) return; sec.dataset.mxlReady = '1';
    var per = Math.max(1, parseInt(sec.dataset.per, 10) || 3), shown = per, loading = false;
    var hist = sec.querySelector('[data-mxrv-hist]'), write = sec.querySelector('[data-mxrv-write]');
    function ready() {
      var w = sec.querySelector('.jdgm-rev-widg'), list = w && w.querySelector('.jdgm-rev-widg__reviews');
      if (!w || !list) return false;
      /* Our score and count, from the widget when the metafields are empty */
      var sc = sec.querySelector('[data-score]'), ct = sec.querySelector('[data-count]');
      if (sc && !sc.textContent.trim() && w.dataset.averageRating) sc.textContent = parseFloat(w.dataset.averageRating).toFixed(1);
      if (ct && !ct.textContent.trim() && w.dataset.numberOfReviews) ct.textContent = w.dataset.numberOfReviews;
      if (w.dataset.numberOfReviews === '0') sec.querySelectorAll('.mxrv__score,.mxrv__stars').forEach(function (el) { el.hidden = true; });
      /* Our own thin bars, from the numbers in Judge.me's histogram */
      if (hist && !hist.dataset.built) {
        var rows = Array.prototype.slice.call(w.querySelectorAll('.jdgm-histogram__row[data-rating]')).filter(function (r) { return /^[1-5]$/.test(r.dataset.rating); });
        if (rows.length) {
          hist.dataset.built = '1';
          hist.innerHTML = '<div class="mxrv-dist">' + rows.map(function (r) { var p = parseFloat(r.dataset.percentage) || 0; return '<div><span>' + r.dataset.rating + ' ★</span><i><b style="width:' + p + '%"></b></i><span>' + Math.round(p) + '%</span></div>'; }).join('') + '</div>';
        }
      }
      /* 09.10.2026: Judge.me's own link stays in its widget (hidden) so its click handler still finds the form;
         our button in the review box clicks it */
      var wl = w.querySelector('.jdgm-write-rev-link');
      if (wl && write && !write.querySelector('.mxrv__write')) {
        var wb = document.createElement('button'); wb.type = 'button'; wb.className = 'mxrv__write';
        wb.textContent = (wl.textContent || '').trim() || 'Write a review';
        wb.addEventListener('click', function () { var l = sec.querySelector('.jdgm-rev-widg .jdgm-write-rev-link'); if (l) l.click(); });
        write.appendChild(wb);
      }
      if (wl) wl.classList.add('mxrv-jdgm-link');
      return true;
    }
    function all() { return Array.prototype.slice.call(sec.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev')); }
    function apply() {
      var list = sec.querySelector('.jdgm-rev-widg__reviews'); if (!list) return;
      var w = sec.querySelector('.jdgm-rev-widg'), revs = all(), total = (w && parseInt(w.dataset.numberOfReviews, 10)) || revs.length;
      revs.forEach(function (r, i) { buildCard(r); r.classList.toggle('mxrv-hide', i >= shown); translatable(r); });
      /* Desktop: "Write a review" exactly as wide as a review card, measured */
      if (write) { var fw = revs[0] ? revs[0].getBoundingClientRect().width : 0; write.style.width = (innerWidth >= 990 && fw) ? fw + 'px' : ''; }
      var more = list.querySelector('.mxrv-more');
      var need = shown < revs.length || revs.length < total;
      if (need && !more) { more = document.createElement('button'); more.type = 'button'; more.className = 'mxrv-more'; more.textContent = sec.dataset.moreLabel || 'Show more reviews'; }
      if (more) { more.textContent = sec.dataset.moreLabel || 'Show more reviews'; if (need) list.appendChild(more); else more.remove(); }
    }
    sec.addEventListener('click', function (e) {
      var more = e.target.closest('.mxrv-more');
      if (more) {
        var revs = all();
        if (shown < revs.length) {
          var from = shown; shown += per;
          apply();
          revs.slice(from, shown).forEach(function (r) { r.classList.remove('mxrv-in'); void r.offsetWidth; r.classList.add('mxrv-in'); });
          return;
        }
        /* Everything loaded is visible: ask Judge.me for the next page (no page reload) */
        var lm = sec.querySelector('.jdgm-paginate__load-more') || sec.querySelector('.jdgm-paginate__next-page');
        if (lm && !loading) { loading = true; more.textContent = '> loading'; shown += per; lm.click(); }
        return;
      }
      var tr = e.target.closest('.mxrv-tr'); if (tr) translate(tr.closest('.jdgm-rev'), tr);
    });
    /* Judge.me builds and pages the widget itself: follow its changes */
    var mo = new MutationObserver(function () {
      if (mo._t) return;
      mo._t = requestAnimationFrame(function () { mo._t = 0; if (ready()) { loading = false; mo.disconnect(); apply(); mo.observe(sec, { childList: true, subtree: true }); } });
    });
    mo.observe(sec, { childList: true, subtree: true });
    window.addEventListener('resize', function () { clearTimeout(sec._rs); sec._rs = setTimeout(apply, 150); });
    if (ready()) apply();
  }
  function translatable(rev) {
    if (rev.dataset.mxrvTr) return; rev.dataset.mxrvTr = '1';
    var body = rev.querySelector('[data-rb]'), title = rev.querySelector('[data-rt]'); if (!body) return;
    var lang = (rev.dataset.reviewLanguage || '').toLowerCase(), text = (title ? title.textContent + '. ' : '') + body.textContent;
    var add = function (src) {
      if (rev.querySelector('.mxrv-tr')) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'mxrv-tr'; b.textContent = 'Translate to English'; if (src) b.dataset.src = src;
      body.insertAdjacentElement('afterend', b);
    };
    if (lang && lang.indexOf('en') !== 0) { add(lang); return; }
    if (!lang && looksForeign(text)) add('');
  }
  function translate(rev, btn) {
    var body = rev.querySelector('[data-rb]'), title = rev.querySelector('[data-rt]');
    if (rev.dataset.mxrvOrig) {
      var o = JSON.parse(rev.dataset.mxrvOrig); delete rev.dataset.mxrvOrig;
      if (title) decode(title, o.t); decode(body, o.b, 800); btn.textContent = 'Translate to English'; return;
    }
    var orig = { t: title ? title.textContent : '', b: body.textContent }, src = btn.dataset.src;
    if ('Translator' in self) {
      btn.textContent = '> translating';
      /* The language: from Judge.me, otherwise the browser's language detector */
      var lang = src ? Promise.resolve(src) : ('LanguageDetector' in self ? self.LanguageDetector.create().then(function (d) { return d.detect(orig.b); }).then(function (r) { return r && r[0] ? r[0].detectedLanguage : ''; }) : Promise.resolve(''));
      lang.then(function (l) { if (!l || l === 'und' || l === 'en') throw new Error('no language'); return self.Translator.create({ sourceLanguage: l, targetLanguage: 'en' }); }).then(function (tr) {
        return Promise.all([orig.t ? tr.translate(orig.t) : '', tr.translate(orig.b)]);
      }).then(function (out) {
        rev.dataset.mxrvOrig = JSON.stringify(orig);
        if (title && out[0]) decode(title, out[0]); decode(body, out[1], 900);
        btn.textContent = 'Translated / show original';
      }).catch(function () { google(orig); btn.textContent = 'Translate to English'; });
    } else google(orig);
  }
  function google(orig) { window.open('https://translate.google.com/?sl=auto&tl=en&op=translate&text=' + encodeURIComponent((orig.t ? orig.t + '\n' : '') + orig.b), '_blank', 'noopener'); }

  function boot() {
    document.querySelectorAll('[data-mxp]').forEach(initDetails);
    document.querySelectorAll('[data-mxr]').forEach(initRelated);
    document.querySelectorAll('[data-mxrv]').forEach(initReviews);
  }
  window.MxLower = { boot: boot, careHTML: careHTML, CARE: CARE };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
